'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weekFromNow.js
// module id = 750
// module chunks = 0